import {DateTimeIsoString} from '@aviary/store/common/common.types';

export const BALANCE_FEATURE_KEY = 'balance';

export interface PatronBalanceTransaction {
  readonly id: number;
  readonly patronId: number;
  readonly branchId: number;
  readonly type: PatronBalanceTransactionType;
  readonly amount: number;
  readonly opacNote: string;
  readonly created: DateTimeIsoString;

  readonly itemTitle: string;
  readonly branchName: string;
  readonly balanceLines: PatronBalanceLine[];

  readonly amountOutstanding: number;
  readonly name: string;
}

export type PatronBalanceTransactionType =
  'PAY_FROM_EXTERNAL' | 'PAY_FROM_WALLET' | 'ADD_CHARGE' | 'WAIVE_CHARGE' | 'ADD_CREDIT_TO_WALLET' | 'REFUND_FROM_WALLET';

export interface PatronBalanceLine {
  readonly id: number;
  readonly transactionId: number;
  readonly amount: number;
  readonly amountOutstanding: number;
  readonly target: PatronBalanceLineTarget;
  readonly created: DateTimeIsoString;
  readonly name: string;
}

export type PatronBalanceLineTarget =
  'BALANCE' | 'WALLET' | 'DEPOSIT';

export interface SquareAppDetails {
  readonly appId: string;
  readonly locationId: string;
  readonly creditType: CreditType;
}

export interface CreditType {
  readonly id: number;
  readonly systemCreditType: SystemCreditType;
  readonly name: string;
  readonly minimumAmount: number;
  readonly defaultOpacNote: string;
}

export type SystemCreditType = 'SQUARE' | 'WAIVE' | 'WALLET_PAYMENT';

export interface MakeAPaymentValue {
  readonly token: string;
  readonly amount: number;
  readonly last4: string;

  // These fields aren't implemented yet, but will be in the future
  readonly cardholderName?: string;
  readonly email?: string;
}

export type PaymentConfirmationValue = MakeAPaymentValue & {
  readonly transactionId: string;
}
